<div class="grid-container padding-y-4">
  <div class="grid-row">
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
      <legend class="usa-legend usa-legend--large">{{rateType}} Rate Filing</legend>
    </div>

    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
      @if (ueiMissing) {
        <div class="alert alert-danger">
          {{ errorMessage }}
        </div>
      }
    </div>
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
      <label class="usa-label">Unique Entity Identifier(UEI): {{uniqueEntityId ? uniqueEntityId : ''}} </label>
    </div>
    @if (domesticApprv) {
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-2">
        <label class="usa-label">USDOT# - Domestic: {{usDotNumber ? usDotNumber : ''}} </label>
      </div>
    }

    @if (domesticApprv) {
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-4">
        <label class="usa-label">Motor Common Carrier Authority - Domestic(MC#): {{mcNumber ? mcNumber : ''}} </label>
      </div>
    }
    @if (domesticApprv) {
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
        <label class="usa-label">Freight Forwarder Authority - Domestic(FF#): {{ffNumberDom ? ffNumberDom : ''}} </label>
      </div>
    }
    @if (intlApprv) {
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
        <label class="usa-label">USDOT# - International: {{usDotNumberIntl ? usDotNumberIntl : ''}} </label>
      </div>
    }
    @if (intlApprv) {
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-2">
        <label class="usa-label">FMC OTI Authority: {{fmcOtiNUmber ? fmcOtiNUmber : ''}} </label>
      </div>
    }
    @if (intlApprv) {
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-4">
        <label class="usa-label">Motor Common Carrier Authority - International(MC#): {{mcNumberIntl ? mcNumberIntl : ''}} </label>
      </div>
    }
    @if (intlApprv) {
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
        <label class="usa-label">Freight Forwarder Authority - International(FF#): {{ffNumberIntl ? ffNumberIntl : ''}} </label>
      </div>
    }

    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
      <div class="usa-alert usa-alert--info usa-alert--no-icon bg-accent-warm">

        <p class="usa-alert__text">
          It is the TSP's responsibility to validate that the information shown above is correct.  If it is not, the TSP must contact the {{contactType}} at <a href>{{contactEmail}}</a> to update it.
        </p>

      </div>
    </div>
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
      @if (showBidCycle) {
        <label class="usa-label maxw-full">
          Available Rate Filing Details: Select the applicable 'Rate Filing Name' and then select 'Continue'
        </label>
      }
    </div>
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
      <ag-grid-angular class="ag-theme-alpine"
        [gridOptions]="bidcyclesGridOptions"
        [rowData]="bidcycles"
        [columnDefs]="columnDefs"
        [overlayNoRowsTemplate]="overlayNoRowsTemplate"
        [suppressDragLeaveHidesColumns]="true"
        (selectionChanged)="onSelectionChanged($event)"
        ag-grid-resize>
      </ag-grid-angular>
    </div>
  </div>
  <div class="grid-row">
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
      <ul class="usa-button-group">
        <li class="usa-button-group__item">
          <button type="button" class="usa-button" (click)="goToCarryOverComponent()" [disabled]="disableContinue">Continue</button>
        </li>
        <li class="usa-button-group__item">
          <button type="button" class="usa-button usa-button--outline" routerLink="/landing">Cancel</button>
        </li>
      </ul>
    </div>
  </div>
</div>

<ng-template #template class="modal fade" role="document" tabindex="-1" role="dialog">
  <div class="usa-modal usa-modal--lg">
    <div class="usa-modal__content">
      <div class="usa-modal__main">
        <h2 class="usa-modal__heading">Warning !!!</h2>
        <div class="usa-prose">
          <div class="grid-row grid-gap">
            @for (mess of warnMessage; track mess) {
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 border" >
                <p>Bidcycle Name : {{mess.bidcycleName}} </p>
                <p>Warning Message : {{mess.warnMessage}} </p>
                <p>Approval Type : {{mess.approvalType}} </p>
                <p>Rate Effective Date : {{mess.rateEffectiveDate}} </p>
              </div>
            }
          </div>
        </div>
        <div class="usa-modal__footer">
          <ul class="usa-button-group">
            <li class="usa-button-group__item">
              <button type="button" class="usa-button" (click)="processHHGRateFilling()">Confirm</button>
            </li>
            <li class="usa-button-group__item">
              <button type="button" class="usa-button usa-button--outline" (click)="bsModalRef.hide()">Cancel</button>
            </li>
          </ul>
        </div>
      </div>
      <button class="usa-button usa-modal__close" (click)="bsModalRef.hide()" aria-label="Close this window" data-close-modal>
        <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
          <use xlink:href="/assets/uswds/img/sprite.svg#close"></use>
        </svg>
      </button>
    </div>

  </div>
</ng-template>
